import { createContext, useContext, useState } from "react";

// Create context
const AutoCopyInfoContext = createContext();

// Provider component
export const AutoCopyInfoProvider = ({ children }) => {
  const [parentAutoCopiedInfo, setParentAutoCopiedInfo] = useState("");

  return (
    <AutoCopyInfoContext.Provider
      value={{ parentAutoCopiedInfo, setParentAutoCopiedInfo }}
    >
      {children}
    </AutoCopyInfoContext.Provider>
  );
};

// Custom hook for easy use
export const useAutoCopyInfo = () => useContext(AutoCopyInfoContext);
